import { Input, Form } from "@renderbus/ui";
import styled, { createGlobalStyle } from "styled-components";

export const ModalStyle = createGlobalStyle`
  .task-eva-modal-title {
    margin: 0;
    background: #18191b;
    border: 1px solid #343538;
    color: #E0EDEF;
    font-size: 14px;
    line-height: 40px;
  }
  .close-icon-wrapper {
    top: 12px;
  }
`;

export const InputComponent = styled(Input)`
  // 去除对应的增减
  &.ant-input-affix-wrapper {
    border: none;
    background-color: #212327;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  &.ant-input-outlined.ant-input-status-error:not(
      .ant-input-disabled
    ):focus-within {
    background-color: #212327;
  }
  &.ant-input-affix-wrapper:hover,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):focus,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):hover {
    background-color: #212327;
  }
`;

export const RechargeForm = styled(Form)`
  padding: 58px 54px 0;
  height: 200px;
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .picture-coupon-code-input {
    margin: 6px 0 4px;
    .icon-input-wrapper {
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid #495359;
      padding: 0;
      .add-btn {
        background-color: #292b2f !important;
      }
      &:hover {
        box-shadow: 0px 0px 0px 2px var(--color-main-alpha-022);
        border: 1px solid var(--main-color) !important;
        transition: border 0.2s ease-in-out;
      }
    }
    input {
      border: 1px solid #495359;
      width: 340px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 8px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
`;
